/**
 * Converts a string having markdown style links to normal anchor tags with href links
 * @param str string to parse which have markdown style links
 * @returns a string parsed string containeing anchor tags with respective hrefs
 */
export const parseLink = (str: string) => {
  return str.replace(/\[(.*?)\]\((.*?)\)/g, (...args) => {
    const [label, link] = args.slice(1, -2)
    return ` <a  target="_blank" rel="noreferrer" class="underline text-primary" href=${link}>${label}</a> `
  })
}
